// Legacy reset password (mantendo compatibilidade)
export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS'
export const USER_RESET_PASSWORD_ERROR = 'USER_RESET_PASSWORD_ERROR'
export const USER_RESET_PASSWORD_RESET = 'USER_RESET_PASSWORD_RESET'

// Generate Token
export const GENERATE_TOKEN_REQUEST = 'GENERATE_TOKEN_REQUEST'
export const GENERATE_TOKEN_SUCCESS = 'GENERATE_TOKEN_SUCCESS'
export const GENERATE_TOKEN_ERROR = 'GENERATE_TOKEN_ERROR'

// Validate Token  
export const VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST'
export const VALIDATE_TOKEN_SUCCESS = 'VALIDATE_TOKEN_SUCCESS'
export const VALIDATE_TOKEN_ERROR = 'VALIDATE_TOKEN_ERROR'

// Change Password
export const CHANGE_PASSWORD_RESET_REQUEST = 'CHANGE_PASSWORD_RESET_REQUEST'
export const CHANGE_PASSWORD_RESET_SUCCESS = 'CHANGE_PASSWORD_RESET_SUCCESS'
export const CHANGE_PASSWORD_RESET_ERROR = 'CHANGE_PASSWORD_RESET_ERROR'

// Reset Password Utils
export const RESET_PASSWORD_UPDATE_STATE = 'RESET_PASSWORD_UPDATE_STATE'
export const RESET_PASSWORD_RESET_STATE = 'RESET_PASSWORD_RESET_STATE'
